import { create } from "zustand";

export const useStoreBulkReveal = create((set) => ({
  contactIds: [],

  // Replace the entire array
  setContactIds: (data) => set({ contactIds: data }),

  // Update a specific contact by id
  updateContactId: (id, updatedData) =>
    set((state) => ({
      contactIds: state.contactIds.map((contact) =>
        contact.id === id ? { ...contact, ...updatedData } : contact
      ),
    })),

  // Add a new contact
  addContactId: (newContact) =>
    set((state) => {
      const exists = state.contactIds.some((contact) => contact.id === newContact.id);
      return exists
        ? {} // no change
        : { contactIds: [...state.contactIds, newContact] };
    }),

  // Remove contact by id
  removeContactId: (id) =>
    set((state) => ({
      contactIds: state.contactIds.filter((contact) => contact.id !== id),
    })),
  removeContactIdsByKey: (key, values = []) =>
    set((state) => ({
      contactIds: state.contactIds.filter((contact) => !values.includes(contact[key])),
    })),
}));
